import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableColumnDef } from "../../components/DataTable";
import { TableThumbnail } from "../../components/TableThumbnail";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildCompanyColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Logo",
    width: "80px",
    render: (row: any) => (
      <TableThumbnail src={lang === "de" ? row?.companyLogo_ger?.[0] : row?.companyLogo?.[0]} />
    ),
  },
  {
    header: "Gesellschaft",
    width: "18%",
    render: (row: any) => (
      <span style={{ wordBreak: "break-word" }}>
        {(lang === "de" ? row?.companyName_ger : row?.companyName) || "-"}
      </span>
    ),
    getValue: (row: any) => lang === "de" ? row?.companyName_ger : row?.companyName,
  },
  {
    header: "E-Mail",
    width: "18%",
    render: (row: any) => (
      <span style={{ wordBreak: "break-word" }}>{row?.email}</span>
    ),
    getValue: (row: any) => row?.email,
  },
  {
    header: "Telefon-Nr.",
    width: "12%",
    render: (row: any) => (
      <span style={{ wordBreak: "break-word" }}>{row?.telephoneNo}</span>
    ),
    getValue: (row: any) => row?.telephoneNo,
  },
  {
    header: "Webseite",
    width: "22%",
    render: (row: any) => (
      <a href={row?.website} target="_blank" rel="noreferrer" style={{ wordBreak: "break-word" }}>
        {row?.website}
      </a>
    ),
  },
  {
    header: "Aktions",
    width: "70px",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Löschen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
